import React, { useEffect, useState } from "react";

const CoreModelTestTTSModal = ({ isOpen, onClose, modelName, onTestTTS, children }) => {
  const [testText, setTestText] = useState("");
  const [languageCode, setLanguageCode] = useState("en-US");

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleTestTTS = () => {
    onTestTTS(testText, languageCode);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black opacity-50 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      <div className="card-glass p-8 rounded-lg z-10 max-w-4xl w-full relative">
      <div className="flex justify-between items-center mb-4">
    <h2 className="text-2xl font-bold text-white">{modelName}</h2>
      <button
          className="text-white text-3xl font-bold hover:text-gray-300 transition-colors duration-200 p-2"
          onClick={onClose}
        >
          ×
        </button>
      </div>
        <div className="mb-4">
          <textarea
            className="bg-gray-600 w-full h-32 text-white rounded p-2 mb-2"
            placeholder="Enter text to test the TTS model..."
            value={testText}
            onChange={(e) => setTestText(e.target.value)}
          ></textarea>
          <div className="flex items-center justify-between space-x-4">
          <select
            className="bg-gray-600 text-white rounded p-2 flex-grow"
            value={languageCode}
            onChange={(e) => setLanguageCode(e.target.value)}
          >
            <option value="en-US">English (US)</option>
            <option value="es-ES">Spanish (Spain)</option>
            <option value="fr-FR">French (France)</option>
          </select>
          <button
            className="bg-blue-600 hover:bg-blue-500 text-white font-bold py-2 px-4 rounded"
            onClick={handleTestTTS}
          >
            Generate
          </button>
          </div>
        </div>
        <div className="mb-4">
          {children} 
        </div>
      </div>
    </div>
  );
};

export default CoreModelTestTTSModal;